export default __webpack_public_path__ + "protected-area-500-c6a8fec17f216a7558f6c1b77765b2da.webp";